<template>
<div>
    <!-- 单选题 -->
    <template v-if="question.question_type == 1">
        <ul class="topic_li">
            <li v-for="(item,index) in question.item_content" :key="index">
                <!-- <input name="answer" class="radio" v-model="radio_answer" :value="item.id" type="radio" @click="doRadio"> -->
                <div><span>{{ chose_item[index] }}. </span><div v-html="item.content" class="item_content"></div></div>
            </li>
        </ul>
    </template>
    <!-- 多选题 -->
    <template v-if="question.question_type == 2">
        <ul class="topic_li">
            <li v-for="(item,index) in question.item_content" :key="index">
                <!-- <input name="answer" class="checkbox" type="checkbox" :value="item.id" v-model="checkbox_answer"> -->
                <div><span>{{ chose_item[index] }}. </span><div v-html="item.content" class="item_content"></div></div>
            </li>
        </ul>
    </template>
    <!-- 判断题 -->
    <template v-if="question.question_type == 3">
        <ul class="topic_li">
            
            <li>
                <!-- <input name="answer" class="radio" v-model="radio_answer" :value="1" type="radio" @click="doRadio"> -->
                <label><span>A. </span>正确</label>
            </li>
            <li>
                <!-- <input name="answer" class="radio" v-model="radio_answer" :value="2" type="radio" @click="doRadio"> -->
                <label><span>B. </span>错误</label>
            </li>
        </ul>
    </template>
    <!-- 填空题 -->
    <template v-if="question.question_type == 4">
        <ul class="topic_li">
            <li  v-for="(item,index) in topic.answer.split(',')" :key="index">
                <input type="text" class="input" v-model="input_answer[index]">
                <label style="float:left;">{{index+1}}、</label>
            </li>
        </ul>
        
    </template>
    <!-- 简答题 -->
    <template v-if="question.question_type == 5">
        <div class="editor"  style="height:100%;">
            <span style="position: absolute;z-index: 999999;left: 219px;line-height: 42px;cursor:pointer;" @click="showHistory">历史记录</span>
            <Editor v-model="editorContent" @blur="onblur" />
            
        </div>
    </template>
    <history :data = "history" @restore = "restore"></history>
</div>
</template>

<script>
import Editor from "@/components/paper/editor"
import Config from "@/infrastructures/config.js"
import History from "@/components/paper/history"

let timer;
export default {
    name: 'options',
    components: {Editor,History},
    props: ['topic'],
    data() {
        return {
            chose_item: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q"],
            question: {},
            radio_answer: '',//单选题答案绑定
            checkbox_answer: [],//多选题答案
            input_answer:[],//填空题
            
            editorContent:"",//当前简答题显示答案
            //initEditorContent:"",


            history:{
                show:false,
                text_answer:[]
            }
            

        }
    },
    created() {
        this.baseUrl = Config.assetUrl;
    },
    computed: {
        answerItem() {
            
            return this.$store.state.answer;
        }
    },
    watch: {
        //单选答案保存
        radio_answer(news) {
            this.saveAnswer(news)
        },
        //多选答案保存
        checkbox_answer(news) {
            this.saveAnswer(news)
        },
        //填空题答案保存
        input_answer(news){
            this.saveAnswer(news);
        },


        //监听试题切换获取试题内容
        topic: {
            immediate: true,
            handler(val) {
                this.question = val;
                this.getCurAnswer(val)
                if(val.question_type == 5){
                    clearInterval(timer);
                    timer = setInterval(()=>{this.saveTextAnswer()},10000);
                    this.history.text_answer = this.answerItem[this.topic.question_id]|| []
                }else{
                    clearInterval(timer);
                }
            }
        },
      
       

    },

    methods: {
        //案例题-----点击历史记录
        showHistory(){
            this.history.show = true;
        },
        //简答题15秒或者blur存储一次
        saveTextAnswer(){
            let answer = this.answerItem[this.topic.question_id]|| [];
            if((answer.length == 0 || this.editorContent != answer.slice(-1)[0].answer)){
                answer.push({
                    answer:this.editorContent,
                    time:this.getNowFormatDate(),
                    type:this.topic.question_type
                });
                this.history.text_answer = answer;
                this.saveAnswer(answer);
            }
        },
        //简答题恢复
        restore(content){
            this.editorContent = content;
            this.saveTextAnswer();
        },
        onblur(){
            this.saveTextAnswer();
        },
        getNowFormatDate() {
            var date = new Date();
			var y = date.getFullYear();
			var m = date.getMonth() + 1;
			var d = date.getDate();
			var h = date.getHours();
			h = h < 10 ? '0' + h : h;
			var min = date.getMinutes();
			min = min < 10 ? '0' + min : min;
			var s = date.getSeconds();
			s = s < 10 ? '0' + s : s;
 
			return y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + s ;
        },

        //获取当前题的答案
        getCurAnswer(val){
            if(val.question_type == 1 || val.question_type == 3){
                //单选、判断
                this.radio_answer = this.answerItem[val.question_id]||'';
            }else if(val.question_type == 2){
                //多选
                this.checkbox_answer = this.answerItem[val.question_id]||[];
                
            }else if(val.question_type == 4){
                //填空
                this.input_answer = this.answerItem[val.question_id]||[];
            }else{
                //案例
                let text_answer = this.answerItem[val.question_id]|| [];
                var jdanswer;
                if(text_answer.length > 0){
                    jdanswer = text_answer.slice(-1)[0].answer;   
                }else{
                    jdanswer = "";
                }
                this.editorContent = jdanswer;
            }

        },
        /*点击单选触发事件，如果选了自动切换下一题，则该事件下触发下一题
        */
        doRadio(item){
            this.$emit("doRadio",item);
        },

        

        //保存答案
        saveAnswer(data) {
            
       
            let cur_question_id = this.question.question_id;
            let answer = this.$store.state.answer || {};
            answer[cur_question_id] = data;
            
            //如果多选的选项是空，则删除这个答案
            if(typeof(data) == "object" && data.length == 0){
                delete answer[cur_question_id]
            }
            if(typeof(data) == 'string' && data == ''){
                delete answer[cur_question_id]
            }
            this.$store.commit("answer", answer);

        },

     

    },
}
</script>

<style lang="scss" scoped>
.topic_li {
    padding-left: 50px;

}

.topic_li li {
    position: relative;
    line-height: 40px;
    // font-size: 14px;
    overflow: hidden;
}

.topic_li .radio,
.topic_li .checkbox {
    position: absolute;
    top: 14px;
    left: 0;
}
.topic_li span{float:left;}
.topic_li div {
    padding-left: 25px;
    float: left;
    overflow: hidden;
    cursor: pointer;
}
.topic_li .item_content{padding-left:4px;float:none;   /* font-family: '仿宋';*/}

.textarea{ display: block;
    width: 77%;
    margin-left: 56px;
    min-height: 200px;}
.input{width:500px;height:30px;line-height:30px;}
</style>
